<div class="register-container">
  <mat-card class="register-card">
    <div class="header">
      <h2>Create an Account</h2>
      <p>Please fill in the information below to register</p>
    </div>

    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>
      <!-- Username -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Username</mat-label>
        <input matInput formControlName="username" required>
        <mat-error *ngIf="registerForm.get('username').invalid">
          {{ getErrorMessage('username') }}
        </mat-error>
      </mat-form-field>

      <!-- First Name -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" required>
        <mat-error *ngIf="registerForm.get('firstName').invalid">
          {{ getErrorMessage('firstName') }}
        </mat-error>
      </mat-form-field>

      <!-- Last Name -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" required>
        <mat-error *ngIf="registerForm.get('lastName').invalid">
          {{ getErrorMessage('lastName') }}
        </mat-error>
      </mat-form-field>

      <!-- Email -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" required>
        <mat-error *ngIf="registerForm.get('email').invalid">
          {{ getErrorMessage('email') }}
        </mat-error>
      </mat-form-field>

      <!-- Password -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" required>
        <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword" type="button">
          <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="registerForm.get('password').invalid">
          {{ getErrorMessage('password') }}
        </mat-error>
      </mat-form-field>

      <!-- Password Strength Indicator -->
      <div class="password-strength-meter" *ngIf="registerForm.get('password').value">
        <div class="strength-label">
          <span>Password Strength:</span>
          <span [ngClass]="{'very-weak': passwordStrength === 0, 'weak': passwordStrength === 1, 'fair': passwordStrength === 2, 'good': passwordStrength === 3, 'strong': passwordStrength >= 4}">
            {{ getPasswordStrengthText() }}
          </span>
        </div>
        <div class="strength-bars">
          <div class="strength-bar" [ngClass]="{'filled': passwordStrength >= 1}"></div>
          <div class="strength-bar" [ngClass]="{'filled': passwordStrength >= 2}"></div>
          <div class="strength-bar" [ngClass]="{'filled': passwordStrength >= 3}"></div>
          <div class="strength-bar" [ngClass]="{'filled': passwordStrength >= 4}"></div>
          <div class="strength-bar" [ngClass]="{'filled': passwordStrength >= 5}"></div>
        </div>

        <div class="strength-requirements">
          <div [ngClass]="{'requirement-met': passwordRequirements.minLength}">
            <mat-icon class="check_circle" *ngIf="passwordRequirements.minLength">check_circle</mat-icon>
            <mat-icon class="cancel" *ngIf="!passwordRequirements.minLength">cancel</mat-icon>
            <span>At least 8 characters</span>
          </div>
          <div [ngClass]="{'requirement-met': passwordRequirements.hasUpperCase}">
            <mat-icon class="check_circle" *ngIf="passwordRequirements.hasUpperCase">check_circle</mat-icon>
            <mat-icon class="cancel" *ngIf="!passwordRequirements.hasUpperCase">cancel</mat-icon>
            <span>Contains uppercase letter</span>
          </div>
          <div [ngClass]="{'requirement-met': passwordRequirements.hasLowerCase}">
            <mat-icon class="check_circle" *ngIf="passwordRequirements.hasLowerCase">check_circle</mat-icon>
            <mat-icon class="cancel" *ngIf="!passwordRequirements.hasLowerCase">cancel</mat-icon>
            <span>Contains lowercase letter</span>
          </div>
          <div [ngClass]="{'requirement-met': passwordRequirements.hasNumber}">
            <mat-icon class="check_circle" *ngIf="passwordRequirements.hasNumber">check_circle</mat-icon>
            <mat-icon class="cancel" *ngIf="!passwordRequirements.hasNumber">cancel</mat-icon>
            <span>Contains number</span>
          </div>
          <div [ngClass]="{'requirement-met': passwordRequirements.hasSpecialChar}">
            <mat-icon class="check_circle" *ngIf="passwordRequirements.hasSpecialChar">check_circle</mat-icon>
            <mat-icon class="cancel" *ngIf="!passwordRequirements.hasSpecialChar">cancel</mat-icon>
            <span>Contains special character</span>
          </div>
        </div>
      </div>

      <!-- Confirm Password -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Confirm Password</mat-label>
        <input matInput formControlName="confirmPassword" [type]="hideConfirmPassword ? 'password' : 'text'" required>
        <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword" type="button">
          <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="registerForm.hasError('passwordMismatch')">
          Passwords do not match
        </mat-error>
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        class="submit-button"
        type="submit"
        [disabled]="registerForm.invalid || loading"
        [attr.aria-busy]="loading">
        <span class="submit-button__inner">
          <mat-spinner *ngIf="loading" class="submit-button__spinner" diameter="20"></mat-spinner>
          <span class="submit-button__label">{{ loading ? 'Please wait...' : 'Register' }}</span>
        </span>
      </button>

      <div class="login-link">
        Already have an account? <a (click)="navigateToLogin()">Log In</a>
      </div>
    </form>
  </mat-card>
</div> 